import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AbsentGlyph, FailedGlyph, PendingGlyph } from "../glyphs.js";
export function ArtifactStateMark({ state, children }) {
    if (state === "present")
        return null;
    const failed = state === "failed";
    return (_jsxs("span", { "data-artifact-mark": state, style: {
            display: "inline-flex", alignItems: "center", gap: "var(--space-075)",
            color: failed ? "var(--ink-1)" : "var(--ink-2)",
            fontWeight: failed ? "var(--type-small-weight-strong)" : "var(--type-small-weight)",
            whiteSpace: "nowrap",
        }, children: [state === "pending" ? _jsx(PendingGlyph, {}) : state === "absent" ? _jsx(AbsentGlyph, {}) : _jsx(FailedGlyph, {}), children] }));
}
